import React from 'react';
// import { withTranslation } from 'react-i18next';
import './Footer.less';
import LanguageSelector from '../LanguageSelector/LanguageSelector';

class Footer extends React.Component {

	render() {
		// const { t } = this.props;
		return (
			<div className="footer">
				<LanguageSelector />
				<a href={process.env.REACT_APP_COMPANY_WEBSITE} rel="noopener noreferrer" target="_blank">{process.env.REACT_APP_COMPANY}</a>
			</div>
		);
	}
}

export default Footer; // withTranslation('translations')(Footer);
